import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';
import { QueryOptions } from '@apollo/client/core';

import { GetAuthor } from '@root/modules/author/types/author';
import getAuthorById from '@root/modules/author/graphql/getAuthorById.graphql';
import { dataLoader } from '@root/libs/redis/dataloader/dataLoader';

type ServiceVariables = GetAuthor['variables'];
type Response = GetAuthor['data'];

export default class AuthorService extends Service implements ServiceInterface {
  private async fetchAuthor(variables: ServiceVariables) {
    try {
      const options = Object.assign({ query: getAuthorById }, { variables });
      const dataLoaderOptions = {
        remote: {
          keyPrefix: 'authorById',
        },
      };

      const requestWrapper = async (options: QueryOptions) => {
        const apiProvider = this.createProvider('GraphQL');
        apiProvider.selectAPI('content-api-v3').setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true });

        const [response] = await apiProvider.query<Response>(options);

        return response.data;
      };

      const redisDataLoader = dataLoader<QueryOptions, Response>(requestWrapper, dataLoaderOptions);
      const response: Response = redisDataLoader ? await redisDataLoader.load(options) : await requestWrapper(options);

      if (!response.authors?.data.length) {
        return false;
      }

      return response.authors.data[0];
    } catch (e) {
      const error = this.generateErrorData(e);
      this.handleError(error);
    }
  }

  public async fetch(variables: ServiceVariables) {
    const response = await this.fetchAuthor(variables);

    return response;
  }
}
